import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        items: '<',
        selectedItems: '=',
        showBulk: '<',
        modalView: '<'
    },
    template: `
            <table class="data01" datatable="ng" dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th class="w1p checkbox sorting_disabled" rowspan="1" colspan="1">
                            <input ng-if="vm.showBulk" type="checkbox" ng-model="vm.checked" ng-click="$event.stopPropagation();vm.toggleAll()"">
                        </th>
                        <th>{{ 'reports.Employee name' | translate }}</th>
                        <th>{{ 'reports.Sites' | translate }}</th>
                        <th>{{ 'reports.Course' | translate }}</th>
                        <th ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ 'reports.Participation' | translate }}</th>
                        <th>{{ 'reports.Version' | translate }}</th>
                        <th>{{ 'reports.Status' | translate }}<br>
                            <small>({{ 'reports.Status creation date' | translate }})</small>
                        </th>
                        <th>{{ 'reports.Progress of mandatory trainings' | translate }}<br>
                            <small>({{ 'reports.Total progress' | translate }})</small>
                        </th>
                        <th>{{ 'reports.Next deadline' | translate }}</th>
                        <th ng-if="!vm.modalView" class="none dt-hide"></th>
                    </tr>
                </thead>
                <tbody class="ui-selectable">
                    <tr ng-repeat="item in vm.items">
                        <td class="w1p checkbox" rowspan="1" colspan="1">
                            <input ng-if="vm.showBulk" type="checkbox"
                                ng-checked="vm.hasItem(item)" ng-click="$event.stopPropagation();vm.toggleItem(item)">
                        </td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.sites }}</td>
                        <td><a ui-sref="authorized.courses.courses.edit.occurrence.edit.general({id: item.courseId, occurrenceId: item.occurrenceId})">{{ item.course }}</a></td>
                        <td ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ item.type }}</td>
                        <td>{{ item.version }}</td>
                        <td>{{ vm.COURSE_STATUS_TYPE_ENUM.LABELS[item.status] }}<br>
                            <small>({{ vm.MomentService.formatDate(item.date) }})</small>
                        </td>
                        <td>{{ item.passedRequiredTrainingCount }}/{{ item.requiredTrainingCount }}<br>
                            <small>({{ item.passedTrainingCount }}/{{ item.trainingCount }})</small>
                        </td>
                        <td>{{ vm.MomentService.formatDate(item.nextDeadline) }}</td>
                        <td ng-if="!vm.modalView">
                            <h3>{{ 'reports.Trainings' | translate }}</h3>
                            <div class="form">
                                <div class="row">
                                    <span class="label">{{ 'reports.Order of trainings' | translate }}</span>
                                    <div class="items">
                                        <span class="text">{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS[item.trainingOrderType] }}</span>
                                    </div>
                                </div>
                            </div>
                            <list-empty list="item.trainings" show-add-message="false"></list-empty>
                            <table class="data01 mt1em" ng-if="item.trainings.length">
                                <thead>
                                    <tr>
                                        <th>{{ 'reports.Training name' | translate }}</th>
                                        <th>{{ 'reports.Type' | translate }}</th>
                                        <th>{{ 'reports.Status' | translate }}</th>
                                        <th>{{ 'reports.Date' | translate }}</th>
                                        <th>{{ 'reports.Duration' | translate }}</th>
                                        <th>{{ 'reports.Result' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr ng-repeat="training in item.trainings">
                                        <td>{{ training.name }}</td>
                                        <td>{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS[training.type] }}</td>
                                        <td>{{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[training.status] }}</td>
                                        <td>{{ vm.MomentService.formatDate(training.date) }}</td>
                                        <td>{{ training.spentDurationFormatted }}</td>
                                        <td>
                                            <span ng-if="training.type===vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST
                                            && training.result">
                                                <a ng-if="vm.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.IN_ASSESSMENT!==training.status"
                                                    ui-sref="authorized.forms.validations.detail({ id: training.occurrenceTrainingProgressId })">
                                                    {{ training.result }}%
                                                </a>
                                            </span>
                                            <span ng-if="training.type===vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE">
                                                <ng-container ng-if="vm.getContentType(training) === 'EPUB'">
                                                    {{ 'reports.Epub progress' | translate }}: {{ training.scormProgress }}%
                                                </ng-container>
                                                <ng-container ng-if="vm.getContentType(training) === 'SCORM'">
                                                    {{ 'reports.Scorm progress' | translate }}: {{ training.scormProgress }}%
                                                </ng-container>
                                                <ng-container ng-if="vm.getContentType(training) === 'OTHER'">
                                                    <div ng-if="training.progressPc">{{ 'reports.Progress' | translate }}: {{ training.progressPc }}%</div>
                                                    <div ng-if="training.chaptersTotal">{{ 'reports.Lessons' | translate }}: {{ training.chaptersPassed }}/{{ training.chaptersTotal }}</div>
                                                    <div ng-if="training.testsTotal">{{ 'reports.Tests' | translate }}: {{ training.testsPassed }}/{{ training.testsTotal }}</div>
                                                </ng-container>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    `
})
export default class {
    constructor (DATATABLES, COURSE_TRAINING_ORDER_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_STATUS_TYPE_ENUM, COURSE_TRAINING_STATUS_TYPE_ENUM, TokenService, MomentService,
                 COURSE_TRAINING_MATERIAL_TYPE_ENUM) {
        this.DATATABLES = DATATABLES;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.TokenService = TokenService;
        this.MomentService = MomentService;
    }

    hasItem (item) {
        return this.selectedItems.find((selectedItem) => item.id === selectedItem.id);
    }

    toggleItem (item) {
        if (this.hasItem(item)) {
            this.selectedItems = this.selectedItems.filter((selectedItem) => selectedItem.id !== item.id);
            this.checked = false;
        }
        else {
            this.selectedItems.push(item);
        }
    }

    toggleAll () {
        this.selectedItems = this.checked ? this.items : [];
    }

    getContentType (training) {
        if (training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM) {
            if (training.scormType === 'EPUB') {
                return 'EPUB';
            }
            return 'SCORM';
        }
        return 'OTHER';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseprogress/table/index.js